import { Loader2, ArrowRight } from "lucide-react";
import { PLAN_ROLES, US_STATES, SERVICE_RADIUS_OPTIONS } from "@/components/auth/signupConstants";
import { DriverProfileFields } from "@/components/auth/DriverProfileFields";
import { CarrierProfileFields } from "@/components/auth/CarrierProfileFields";
import { BrokerProfileFields } from "@/components/auth/BrokerProfileFields";

export const RegisterForm = ({ form, setForm, update, toggleArrayValue, loading, isDriverRole, isCarrierRole, isBrokerRole, onSubmit }) => (
  <form onSubmit={onSubmit} data-testid="register-form" className="space-y-3">
    <input required data-testid="register-name-input" placeholder="Full name" value={form.name} onChange={update("name")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    <input required type="email" data-testid="register-email-input" placeholder="Email" value={form.email} onChange={update("email")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    <input required type="password" data-testid="register-password-input" placeholder="Password" value={form.password} onChange={update("password")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    <select data-testid="register-role-select" value={form.role} onChange={update("role")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm bg-white focus:outline-none focus:border-rr-orange">
      {PLAN_ROLES.map((r) => (
        <option key={r.value} value={r.value}>{r.label}</option>
      ))}
    </select>

    <div className="pt-2 border-t border-rr-line">
      <div className="text-xs font-bold tracking-wide uppercase text-rr-muted mb-2 mt-3">Where you operate</div>
      <div className="grid grid-cols-2 gap-3">
        <input required data-testid="register-city-input" placeholder="City" value={form.city} onChange={update("city")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
        <select required data-testid="register-state-select" value={form.state} onChange={update("state")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm bg-white focus:outline-none focus:border-rr-orange">
          <option value="">State</option>
          {US_STATES.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <input type="tel" data-testid="register-phone-input" placeholder="Phone number" value={form.phone} onChange={update("phone")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
        <select data-testid="register-service-radius-select" value={form.serviceRadius} onChange={update("serviceRadius")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm bg-white focus:outline-none focus:border-rr-orange">
          {SERVICE_RADIUS_OPTIONS.map((r) => (
            <option key={r} value={r}>Up to {r} mi</option>
          ))}
        </select>
      </div>
    </div>

    {isDriverRole && <DriverProfileFields form={form} update={update} toggleArrayValue={toggleArrayValue} />}
    {isCarrierRole && <CarrierProfileFields form={form} update={update} />}
    {isBrokerRole && <BrokerProfileFields form={form} update={update} toggleArrayValue={toggleArrayValue} />}

    <label className="flex items-start gap-2.5 text-xs text-rr-muted cursor-pointer pt-1">
      <input
        required
        type="checkbox"
        data-testid="register-age-checkbox"
        checked={form.ageConfirmed}
        onChange={(e) => setForm((f) => ({ ...f, ageConfirmed: e.target.checked }))}
        className="mt-0.5 accent-rr-orange"
      />
      I confirm that I am at least 18 years old.
    </label>

    <button type="submit" disabled={loading || !form.ageConfirmed} data-testid="register-submit-button" className="w-full bg-rr-orange text-white font-bold py-3.5 rounded-full hover:bg-rr-navy transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
      {loading ? <Loader2 size={18} className="animate-spin" /> : <>Create Account & Subscribe <ArrowRight size={16} /></>}
    </button>
    <p className="text-xs text-rr-muted text-center">
      By creating an account you agree to our{" "}
      <a href="/legal/terms" target="_blank" rel="noreferrer" className="underline hover:text-rr-orange">Terms</a> and{" "}
      <a href="/legal/privacy" target="_blank" rel="noreferrer" className="underline hover:text-rr-orange">Privacy Policy</a>. You'll be redirected to a secure Stripe checkout to activate your plan.
    </p>
  </form>
);
